import { Dialog, Icon, Icons, Intent } from "construct-ui";
import { FILE_EXTENSIONS } from "../../../config/constants";
import goodMovementModel from "../../../models/posm/goods-movement.model";
import ViewBase from "../../../views/view-base.view";
import FileUploadInputComponent from "../../file/file-upload-input.component";
import SelectSiteSearchInputComponent from "../../site/select-site-search-input.component";
import QtyNumberInputComponent from "./qty-number-input.component";

export default function AddRetailerComponent() {
  ViewBase.call(this);

  const FORM_ID = 'ChannelQtyExcelUploadForm'

  let isOpen = false;
  let file = null;
  let resultTableData = [];

  const downloadRetailQtyExcelTemplate = () => {
    this.showLoading();
    goodMovementModel.downloadRetailQtyTemplate()
      .catch((error) => { this.handleError(error) })
      .finally(() => { this.hideLoading() })
  }

  const handleCloseDialogButtonClick = () => {
    isOpen = false;
    file = null;
    resultTableData = [];
  }

  const upload = (e, basicModelId, storageId) => {
    e.preventDefault();
    if (!this.validateForm(e, `#${FORM_ID}`)) {
      return
    }
    this.showLoading();
    let formData = new FormData()
    formData.append('basicModelId', basicModelId)
    formData.append('fileInput', file)
    formData.append('storageId', storageId)
    goodMovementModel.uploadRetailQty(formData)
      .then((result) => {
        if (result?.length)
          resultTableData = result
        else resultTableData = [];
      }).catch((error) => {
        this.handleError(error);
        resultTableData = [];
      }).finally(() => {
        this.hideLoading();
      })
  }

  let addToChannelItem = (toChannelCode) => {
    document.getElementById('CreateGoodsMovementForm').classList.remove('was-validated');
    toChannelCode.unshift({
      code: null,
      name: null,
      retailQty: 0,
      qty: 0
    })
  }

  const checkAlreadyExistedRetail = (toChannelCode, selectedSiteId) => {
    return toChannelCode.some(item => item.code === selectedSiteId)
  }

  const sumQty = (arr, qtyKey) => arr.reduce((previousValue, currentValue) => {
    return previousValue + parseInt(currentValue[qtyKey] ? currentValue[qtyKey] : 0, 10)
  }, 0)

  const handleConfirmClick = (toChannelCode, maxQty) => {
    if (resultTableData.some(item => checkAlreadyExistedRetail(toChannelCode, item.channelCode))) {
      this.showErrorMessage(this.getText('EM00000831', 'Retail(s) is already existed. Please input another.'))
      return
    }
    let resultTableSumQty = sumQty(resultTableData, 'uploadQty')
    let currentToChannelCodeSumQty = sumQty(toChannelCode, 'qty')
    if (resultTableSumQty + currentToChannelCodeSumQty > maxQty) {
      this.showErrorMessage(this.getText('EM00000832', 'The sum of all quantity to issue must be less than or equal to the current storage quantity.'))
      return
    }

    toChannelCode.unshift(...resultTableData.map(({ channelCode, uploadQty, channelName, stockQty }) => ({
      code: channelCode,
      name: channelName,
      retailQty: stockQty,
      qty: uploadQty
    })))
    handleCloseDialogButtonClick()
  }
  return {
    view: ({ attrs: { movementDetailInfo: { toChannelCode, basicModelId, editQtyYN, basicModelName, fromStorageId }, maxQty } }) => {
      return [
        toChannelCode.map((item, index) => {
          let currentMaxQty = maxQty - toChannelCode.reduce((previousValue, currentValue, currentIndex) => {
            if (currentIndex === index) return previousValue;
            return previousValue + parseInt(currentValue.qty ? currentValue.qty : 0, 10)
          }, 0)
          return m('.row.g-2', [
            m('.col-4.position-relative',
              m('label.form-label.mandatory[for="toRetail"]', this.getText('LT00001263', 'To Retail')),
              m(SelectSiteSearchInputComponent, {
                required: true,
                multiple: false,
                disabled: editQtyYN !== 'Y',
                selectedItem: { siteId: item.code, siteName: item.name },
                onSelect: (sites) => {
                  if (checkAlreadyExistedRetail(toChannelCode, sites.siteId)) {
                    this.showErrorMessage(this.getText('EM00000831', 'Retail(s) is already existed. Please input another.'))
                    return
                  }

                  item.code = sites.siteId
                  item.name = sites.siteName
                  goodMovementModel.getChannelGoodsQty({ channelCode: sites.siteId, basicModelId: basicModelId })
                    .then((result) => {
                      item.retailQty = result?.qty;
                    }).catch((error) => {
                      this.handleError(error)
                    })
                }
              }),
              m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
            ),
            m('.col-2.position-relative',
              m('label.form-label[for="retailQty"]', this.getText('LT00001260', 'Retail Qty')),
              m(`input#retailQty.form-control.form-control-bg[type=number][placeholder=${this.getText('LT00001260', 'Retail Qty')}]`, {
                readonly: true,
                disabled: true,
                value: item.retailQty
              }),
            ),
            m('.col-2.position-relative',
              m('label.form-label.mandatory[for="qty"]',
                this.getText('LT00001283', 'Qty')
              ),
              m(QtyNumberInputComponent, {
                placeholder: this.getText('LT00001283', 'Qty'),
                required: true,
                min: 1,
                max: currentMaxQty,
                disabled: editQtyYN !== 'Y',
                value: item.qty,
                onChange: (value) => { item.qty = value },
              })
            ),
            m('.col-md-4.d-flex.align-items-end.gap-2',
              index === 0
                ? [
                  m('button.btn.btn-white', {
                    style: 'margin-bottom: 2px',
                    type: 'button',
                    disabled: editQtyYN !== 'Y',
                    onclick: () => { addToChannelItem(toChannelCode) }
                  },
                    m("i.bi.bi-plus-lg"),
                    this.getText('LT00000090', 'Add')
                  ),
                  m('button.btn.btn-white', {
                    style: 'margin-bottom: 2px',
                    type: 'button',
                    disabled: editQtyYN !== 'Y',
                    onclick: () => { isOpen = true }
                  },
                    m("i.bi.bi-file-earmark-arrow-up-fill"),
                    this.getText("LT00000197", "Excel Upload")
                  )
                ]
                : m(Icon, {
                  class: 'py-3',
                  intent: Intent.NEGATIVE,
                  name: Icons.X,
                  onclick: () => {
                    if (editQtyYN === 'Y')
                      toChannelCode.splice(index, 1);
                  },
                  size: 'lg',
                })
            )
          ])
        }),
        m(Dialog, {
          isOpen,
          onClose: handleCloseDialogButtonClick,
          class: 'cui-dialog-xxl',
          title: this.getText('LT00001264', 'Retail Qty Excel Upload'),
          closeOnOutsideClick: false,
          content: [
            m('.card.mb-3',
              m('.card-body',
                m('form.position-relative.needs-validation[novalidate]', {
                  id: FORM_ID, onsubmit: (e) => {
                    upload(e, basicModelId, fromStorageId)
                  }
                },
                  m('.row.gap-3',
                    m('.col-4',
                      `${this.getText('LT00001268', 'Basic Model')}: ${basicModelName}`
                    ),
                    m('.col-12.position-relative',
                      m(FileUploadInputComponent, {
                        accept: FILE_EXTENSIONS.XLSX,
                        required: true,
                        onTemplateDownloadClick: downloadRetailQtyExcelTemplate,
                        onInput: (data) => { file = data; },
                        requiredInvalidText: this.getText('LT00000729', 'This field is required'),
                      }),
                    ),
                    m('small.text-danger', this.getText('', 'Disclaimer: Duplicated records will be removed')),
                    m('.col-12.d-flex.justify-content-end',
                      m('button.btn.btn-primary', { type: 'submit', form: FORM_ID, disabled: !!!file }, this.getText("LT00000290", "Upload"))
                    )
                  )
                )
              )
            ),
            m('.card',
              m('.card-body',
                m('.row.gap-3',
                  m('.col-12',
                    m('.table-responsive',
                      m('table.table.table-hover',
                        m('thead',
                          m('tr.align-middle',
                            m('th[scope="col"]', this.getText('LT00001244', 'Retail Code')),
                            m('th[scope="col"]', this.getText('LT00001245', 'Retail')),
                            m('th[scope="col"]', this.getText('LT00001260', 'Retail Qty'),),
                            m('th[scope="col"]', this.getText('LT00001265', 'Upload Qty'),),
                            m('th[scope="col"]', this.getText('LT00000152', 'Remarks'))
                          )
                        ),
                        m('tbody',
                          (resultTableData.length == 0) &&
                          m('tr.align-middle',
                            m('td[colSpan=13]', this.getText("EM00000141", "No records found."))
                          ),
                          resultTableData.length > 0 &&
                          resultTableData.map((data, index) =>
                            m('tr.align-middle',
                              m('td', m('span.cursor-text', data.channelCode)),
                              m('td', m('span.cursor-text', data.channelName)),
                              m('td', m('span.cursor-text', data.stockQty)),
                              m('td', m('span.cursor-text', data.uploadQty)),
                              m('td', m('span.cursor-text', data.remarks))
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            ),
            this.getBaseViews()
          ],
          footer: [
            m('.d-flex.justify-content-end.gap-2',
              m('button.btn.btn-primary', {
                disabled: resultTableData.length === 0 || resultTableData.some(({ channelName }) => !channelName),
                onclick: () => { handleConfirmClick(toChannelCode, maxQty) },
              }, this.getText('LT00000043', 'Confirm')),
              m('button.btn.btn-white', {
                onclick: () => { handleCloseDialogButtonClick() },
              }, this.getText('LT00000021', 'Close')),
            )
          ]
        }),
        this.getBaseViews()
      ]
    }
  }
}